// @ts-strict-ignore
import React from "react";

import { ContentfulTextArray } from "components/parts/ContentfulText";

import styled from "@emotion/styled";

import { BaseComponentWrapper } from "design-components/baseComponent/BaseComponent.styled";
import { ContentfulButton } from "components/parts/ContentfulButton";
import { ContentfulThemeProvider } from "components/parts/ContentfulThemeProvider";

export const ButtonWrapper = styled.div`
  text-align: center;
`;

export const CommonHero = (props) => {
  const { theme, text, styles, cta } = props;

  return (
    <ContentfulThemeProvider theme={theme}>
      <BaseComponentWrapper {...styles} textAlign={"center"}>
        <ContentfulTextArray text={text} />
        <ButtonWrapper>
          <ContentfulButton {...cta?.[0]} />
        </ButtonWrapper>
      </BaseComponentWrapper>
    </ContentfulThemeProvider>
  );
};
